import { VuexModule, Module, Action, Mutation, getModule } from "vuex-module-decorators";
import { store } from "@/store/store";
import { graphqlClient } from "@/utils/graphql";
import {
  ProductInOverview,
  ProductOverviewQueryResult,
  QUERY_PRODUCT_OVERVIEW
} from "@/models/queries/ProductOverviewQuery";
import { parseToNumber, valueOrEmpty } from "@/utils/number";
import gql from "graphql-tag";
import { DELETE_PRODUCT_MUTATION } from "@/models/mutations/DeleteProduct";
import { DeleteProduct, DeleteProductVariables } from "@/models/mutations/types/DeleteProduct";
import { OperationResult } from "@/models/graphql-global-types";

export interface INewProductStoreState {
  hasError: boolean;
  loading: boolean;
  products: ProductInOverview[];
}

@Module({ dynamic: true, store, name: "newProductStore" })
class NewProduct extends VuexModule implements INewProductStoreState {
  public hasError: boolean = false;
  public loading: boolean = false;
  public products: ProductInOverview[] = [];

  @Mutation
  private START_FETCHING_OVERVIEW() {
    this.hasError = false;
    this.loading = true;
  }

  @Mutation
  private DID_FETCH_PRODUCT_OVERVIEW(products: ProductInOverview[]) {
    this.loading = false;
    this.products = products;
  }

  @Mutation
  private ERROR_FETCHING_PRODUCT_OVERVIEW() {
    this.loading = false;
    this.products = [];
    this.hasError = true;
  }

  @Action
  public async fetchOverview() {
    try {
      this.START_FETCHING_OVERVIEW();
      const result = await graphqlClient.query<ProductOverviewQueryResult>({
        query: QUERY_PRODUCT_OVERVIEW
      });
      if (result.data && !result.errors) {
        this.DID_FETCH_PRODUCT_OVERVIEW(
          result.data.products.map(product => ({
            ...product,
            screwDiameter: parseToNumber(product.screwDiameter?.replace(/[^0-9,.]/g, "")),
            screwLength: parseToNumber(product.screwLength?.replace(/[^0-9,.]/g, ""))
          }))
        );
      } else {
        this.ERROR_FETCHING_PRODUCT_OVERVIEW();
      }
    } catch (e) {
      console.error(e);
      this.ERROR_FETCHING_PRODUCT_OVERVIEW();
    }
  }

  @Action
  public async deleteProduct(productId: string) {
    const result = await graphqlClient.mutate<DeleteProduct, DeleteProductVariables>({
      mutation: DELETE_PRODUCT_MUTATION,
      variables: {
        productId
      }
    });

    if (result.data?.deleteProduct === OperationResult.SUCCESS) {
      this.DID_FETCH_PRODUCT_OVERVIEW(this.products.filter(p => p.id !== productId));
    } else {
      throw new Error();
    }
  }
}

export const NewProductStore = getModule(NewProduct);
